export default __webpack_public_path__ + "static/media/bag_w_code.b1acaa9f.png";